export function request(chatId) {
    return {
        type: 'TRADER_CHAT_GET_CHAT_REQUEST',
        chatId
    };
}

export function error(chatId, errors) {
    return {
        type: 'TRADER_CHAT_GET_CHAT_ERROR',
        chatId,
        errors
    };
}

export function finish(chatId, { assignee, messages }) {
    return {
        type: 'TRADER_CHAT_GET_CHAT_FINISH',
        chatId,
        messages,
        assignee
    };
}
